import {fetch} from "../../utils/dataAccess";

export default async function getStripeLink(retailerId) {
    const response = await fetch(`/retailer/stripe_link?retailer=${retailerId}`,{signal: null});

    return await response.json();
}
